import { useParams } from 'next/navigation'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { selectors } from 'store/selectors'

import { isParameterCatalogUrl } from '@/shared/lib/utils/url/isParametrCatalogUrl'

export const useCurrentCategory = () => {
	const params = useParams()
	const categories = useSelector(selectors.categoriesItems)
	const slugParam = params?.slug as string | string[] | undefined
	const [firstSlug, secondSlug, thirdSlug] = (Array.isArray(slugParam) ? slugParam : [slugParam]).filter(
		Boolean
	) as string[]
	const seoSlug = secondSlug === `filter` && thirdSlug ? (!isParameterCatalogUrl(thirdSlug) ? thirdSlug : null) : null
	const parentCategory = useMemo(() => categories.find(({ code }) => code === firstSlug), [firstSlug])
	const seoCategory = useMemo(() => (seoSlug ? categories.find(({ code }) => code === seoSlug) : null), [seoSlug])
	const currentCategory = seoCategory || parentCategory
	const subCategories = useMemo(
		() => categories.filter(section => section.parentId === parentCategory?.id),
		[currentCategory?.id, categories]
	)

	return { currentCategory, subCategories, categories }
}
